import { ActionTypes } from '../constans/action-types';

const initialState = {
  vendxSessionId: null,
  transScriptSession: '',
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_VENDX_SESSION_ID:
      return {
        ...state,
        vendxSessionId: action.payload,
      };
    case ActionTypes.SET_TRANSCRIPT_SESSION:
      return {
        ...state,
        transScriptSession: action.payload,
      };
    default:
      return state;
  }
};
export default sessionReducer;
